// extracted by mini-css-extract-plugin
module.exports = {"action":"DeclarationForm__action--3ZiNx","wrap":"DeclarationForm__wrap--38C3v","empty_messages":"DeclarationForm__empty_messages--EWJVW"};